import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

import { VehicleLocation, VehicleLocationFormValues } from "./types";
import { transformVehicleLocation, transformVehicleLocationOnSave } from "./transformations";

/*---------------------------------------------------------------------------------------
    PREMJEŠTAJ VOZILA
  -----------------------------------------------------------------------------------------*/
export const transferVehicleAPI = async (
  vehicleId: string,
  formValues: VehicleLocationFormValues,
  t: (key: string) => string
): Promise<VehicleLocation> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${vehicleId}/locations`,
      method: "POST",
      body: transformVehicleLocationOnSave(formValues),
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.location.transfer.success"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformVehicleLocation(response.data);
};

/*---------------------------------------------------------------------------------------
    ISPRAVAK PREMJEŠTAJA
  -----------------------------------------------------------------------------------------*/
/**
 * Mijenja postojeći premještaj umjesto da otvara novi. Backend uz njega poravnava datume
 * susjednih premještaja, pa povijest ostaje bez rupa.
 */
export const updateVehicleTransferAPI = async (
  vehicleId: string,
  locationId: string,
  formValues: VehicleLocationFormValues,
  t: (key: string) => string
): Promise<VehicleLocation> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${vehicleId}/locations/${locationId}`,
      method: "PUT",
      body: transformVehicleLocationOnSave(formValues),
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.location.update.success"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformVehicleLocation(response.data);
};

/*---------------------------------------------------------------------------------------
    BRISANJE PREMJEŠTAJA
  -----------------------------------------------------------------------------------------*/
/**
 * Označava premještaj obrisanim. Backend uz to zatvara povijest oko njega — prethodni
 * premještaj preuzima njegov kraj, a ako je bio aktivan, vozilo se vraća na prethodnu lokaciju.
 */
export const deleteVehicleTransferAPI = async (
  vehicleId: string,
  locationId: string,
  t: (key: string) => string
): Promise<void> => {
  await createApiCall(
    {
      path: `/v1/fleet/vehicles/${vehicleId}/locations/${locationId}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.location.delete.success"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();
};

/*---------------------------------------------------------------------------------------
    POVIJEST PREMJEŠTAJA
  -----------------------------------------------------------------------------------------*/
export const getVehicleLocationsAPI = async (
  vehicleId: string
): Promise<VehicleLocation[]> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${vehicleId}/locations`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data.map(transformVehicleLocation);
};
